<div class="main-selector">
  <fibra-company-list></fibra-company-list>
  <fibra-profile-list [hidden]="true"></fibra-profile-list>
</div>
<div class="content-page">
  <fibra-breadcrumb bottom="0" infoAccount="Openbanking" roule="Termo de uso" arrow="false" downloadDoc="">
  </fibra-breadcrumb>
  <fibra-accept-doc [doc]="document"></fibra-accept-doc>
</div>